import { combineReducers } from 'redux';
import statCounter from './statCounter';
import locationSelectReducer from './locationSelectReducer';

const allReducers = combineReducers({
    statCounter,
    locationSelectReducer,
});

export default allReducers;